export default __webpack_public_path__ + "static/media/video-camera-white.7da5d479.svg";